import { Btn, H4, H6, LI, P, UL } from "../../../../../AbstractElements";
import { ProductDetails } from "../../../../../Constants/Constants";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { ModalProductDetailsProp } from "../../../../../Types/EcommerceType";

export const ModalProductDetails:React.FC<ModalProductDetailsProp> = ({ singleProduct }) => {
  const ProductSizeArray: string[] = ["M", "L", "Xl"];

  const { symbol } = useAppSelector((state) => state.product);
  return (
    <>
      <H4>{singleProduct.category}</H4>
      <div className="product-price fs-4 mb-2">
        {symbol}
        {singleProduct.price}
        <del className="f-w-700 fs-5 ms-1">
          {symbol}
          {singleProduct.discountPrice}
        </del>
      </div>
      <div className="product-view">
        <H6 className="f-w-600 text-capitalize">{ProductDetails}</H6>
        <P className="mb-0">{singleProduct.discription}</P>
      </div>
      <div className="product-size mt-3 mb-2">
        <UL className="d-flex simple-list flex-row">
          {ProductSizeArray.map((items, i) => (
            <LI key={i} className="me-2">
              <Btn outline color="light">
                {items}
              </Btn>
            </LI>
          ))}
        </UL>
      </div>
    </>
  );
};
